import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { Despose } from './components';
const Despose = lazy(() => import(/* webpackChunkName: "Despose" */ './components'));
const routes = () => (
  <PrivateRoute exact path="/settings/dispose" component={Despose} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Despose/routes.js